import {
  ImmutableMerkleTree
} from '../immutable_merkle_tree.js';
import {
  jsonToMerkleTree,
  findNodeByJsonPath,
  hasNodeByJsonPath,
} from './json_merkle.js';
import defaultHashFn from './default_hash.js';
import {
  updateHashByPath
} from '../merkle_tree.js';
import writeOps from './write_ops.js';
import readOps from './read_ops.js';

const ImmutableJsonMerkleTree = function(json, hashFn = defaultHashFn) {
  const root = jsonToMerkleTree(json, hashFn);
  this.hashFn = hashFn;
  this.immutableTree = new ImmutableMerkleTree(root);
  this.readonly = false;
};

ImmutableJsonMerkleTree.prototype = Object.assign({},
  writeOps,
  readOps,

  {
    // create a new read only sub tree
    sub: function(jsonPath) {
      const {
        node,
      } = findNodeByJsonPath(this.immutableTree.root, jsonPath);

      return this._subByNode(node);
    },

    _subByNode: function(node) {
      const t = new ImmutableJsonMerkleTree(null, this.hashFn);
      t.immutableTree = new ImmutableMerkleTree(node);
      t.readonly = true;
      return t;
    },

    getRootJsonPath: function() {},

    createNewImmutableJsonMerkleTreeByJsonPath: function(jsonPath, handler, ...params) {
      // create new merkle tree
      const {
        newTree,
        newNode,
        path,
      } = this.createNewImmutableMerkleTreeByJsonPath(jsonPath);

      if (handler) {
        handler({
          newNode,
          hashFn: this.hashFn,
        }, ...params);

        // update hash
        updateHashByPath(newTree.root, path);
      }

      const v = new ImmutableJsonMerkleTree(null, this.hashFn);
      v.immutableTree = newTree;

      return v;
    },

    // create a new immutable merkle tree by json path
    createNewImmutableMerkleTreeByJsonPath: function(jsonPath) {
      const {
        path,
      } = findNodeByJsonPath(this.immutableTree.root, jsonPath);

      // create new merkle tree
      const newTree = this.immutableTree.createNewImmutableMerkleTreeByPath(path);

      const newNode = newTree.root.findNodeByPath(path);

      return {
        newTree,
        path,
        newNode,
      };
    },

    has: function(jsonPath) {
      const {
        has,
      } = hasNodeByJsonPath(this.immutableTree.root, jsonPath);

      return has;
    },
  });

export {
  ImmutableJsonMerkleTree
};
